















































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import GroupsBookingDetails from "./GroupsBookingDetails.vue";

import UserJson from "../../shared/UserJson";
import GroupBookingJson from "../../shared/GroupBookingJson";
import { GroupBookingStatus } from "../../shared/GroupBookingStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "GroupsAll",
  components: {
    Loading,
    TableView,
    GroupsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    GroupsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      groupBookings: null as GroupBookingJson[] | null,
      groupBookingsMoreAvailable: null as boolean | null,
      searchString: null as string | null,
      selectedGroupBookingId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: GroupBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedGroupBookingId = item.ID;
      } else {
        this.selectedGroupBookingId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadGroupBookings();
    },

    async loadGroupBookings(loadMore: null = null) {
      var states: GroupBookingStatus[] | null = null;

      var afterDateTime = null;
      var beforeDateTime = null;
      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.groupBookings != null) {
        this.groupBookingsMoreAvailable = null;

        skipAmount = this.groupBookings.length;
      } else {
        this.groupBookings = null;
      }

      //final load
      if (this.restClient != null && this.loginUser) {
        try {
          let bookings = await this.restClient.getGroupBookings(
            states,
            this.loginUser.ID,
            afterDateTime,
            beforeDateTime,
            this.searchString,
            null,
            skipAmount
          );

          if (loadMore && this.groupBookings != null) {
            this.groupBookings = this.groupBookings.concat(bookings.groupBookings);
          } else {
            this.groupBookings = bookings.groupBookings;
          }

          this.groupBookingsMoreAvailable = bookings.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadGroupBookings();
    },

    resetSearchString() {
      this.searchString = "";
      this.loadGroupBookings();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    groupColumns: function (): TableViewColumnDefinitions<GroupBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Gruppe",
          td: (i) => (i.customer.guardianOrganisation != "" ? i.customer.guardianOrganisation : "--"),
        },
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateWeekday(new Date(i.beginDateTime)),
          sortBy: (i) => i.beginDateTime,
        },
        {
          th: "Uhrzeit",
          td: (i) =>
            DateFormatter.formatTime(new Date(i.beginDateTime)) +
            " – " +
            DateFormatter.formatTime(new Date(i.endDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.GroupsBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<GroupBookingJson>[];
    },
  },
});
